import React, { useEffect, useState } from 'react';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAsync, selectTiposEmbalagens } from '../../features/tipo-embalagem-nacional/tipoEmbalagemNacionalSlice';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function SelectMotivoSituacaoDespacho({
  label,
  name,
  initialValues,
  ...restProps
}) {

  const list = [
    {id: 1, description: 'Despacho para consumo de mercadoria admitida em regime especial, exceto ATUE, Repetro-Temporário e GNL-Temporário'},
    {id: 2, description: 'Transferência para outro regime especial / substituição do beneficiário'},
    {id: 3, description: 'Nacionalização de mercadoria admitida em DE/DAF ou Recof após o fim do prazo de vigência'},
    {id: 4, description: 'Importação de bens objeto de exportação sem saída do território nacional'},
    {id: 5, description: 'Despacho para consumo de resíduo proveniente de destruição de bem admitido em regime aduaneiro especial'},
    {id: 6, description: 'Despacho para consumo de bem admitido temporariamente no País para utilização econômica, incluindo Repetro e GNL'},
    {id: 7, description: 'Nova Admissão Temporária para Utilização Econômica (art. 75 da IN/RFB 1600/2015)'},
  ]

  const [defaultValue, setDefaultValue] = useState('');


  useEffect(() => {
    const value = list.find((item) => item?.id === _.get(initialValues, name));
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }
  }, [initialValues]);

  const filterOptions = createFilterOptions({
    stringify: (item) => (
      `${item?.code} - ${item?.description}`
    ),
  });

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (
        item?.id && item?.description
          ? `${item?.id} - ${item?.description}`
          : ''
      )}
      {...restProps}
    />
  );
}
